import React, { createContext, useContext, useState, useCallback, useEffect } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth.jsx";

const TourCtx = createContext(null);

export function TourProvider({ children }) {
  const { user, refreshUser } = useAuth();
  const [run, setRun] = useState(false);

  // Auto-start the tour on first login of a fresh user.
  useEffect(() => {
    if (!user) return;
    const authPaths = ["/login", "/signup", "/verify-email", "/forgot-password", "/reset-password", "/auth-callback"];
    if (authPaths.includes(window.location.pathname)) return;
    if (user.has_seen_tour === false) {
      const t = setTimeout(() => setRun(true), 600);
      return () => clearTimeout(t);
    }
  }, [user]);

  const startTour = useCallback(async () => {
    // Reset the seen flag so the auto-start effect wouldn't accidentally re-arm on refresh;
    // then start immediately.
    try { await api.post("/auth/tour-reset"); } catch { /* ignore */ }
    setRun(false);
    // Force remount of Joyride to re-run steps cleanly
    setTimeout(() => setRun(true), 50);
  }, []);

  const finishTour = useCallback(async () => {
    setRun(false);
    try {
      await api.post("/auth/tour-complete");
      await refreshUser();
    } catch { /* ignore */ }
  }, [refreshUser]);

  return (
    <TourCtx.Provider value={{ run, setRun, startTour, finishTour }}>
      {children}
    </TourCtx.Provider>
  );
}

export const useTour = () => useContext(TourCtx);
